import { useTranslation } from "react-i18next";

import { Group } from "#shared/view/components/Group";
import { Modal } from "#shared/view/components/Modal";
import { Text } from "#shared/view/components/Text";
import { Button } from "#shared/view/designSystem/Button";
import { Checkbox } from "#shared/view/designSystem/Checkbox";

interface CreateBatchDisclaimerModalProps {
  opened: boolean;
  onClose: () => void;
  onConfirm: () => void;
  confirmLabel: string;
  checkboxProps: {
    id: string;
    checked: boolean;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  };
}

export function CreateBatchDisclaimerModal({
  opened,
  onClose,
  onConfirm,
  checkboxProps,
  confirmLabel,
}: CreateBatchDisclaimerModalProps) {
  const { t } = useTranslation();

  return (
    <Modal opened={opened} onClose={onClose} title={t("qrl.batch.disclaimerTitle")} centered>
      <Text mb="md">{t("qrl.batch.disclaimerText")}</Text>
      <Group align="center" mb="md">
        <Checkbox {...checkboxProps} label={t("qrl.batch.dontShowAgain")} />
      </Group>
      <Group justify="flex-end" mt="md" gap="xs">
        <Button variant="outline" onClick={onClose}>
          {t("qrl.batch.cancel")}
        </Button>
        <Button onClick={onConfirm}>{confirmLabel}</Button>
      </Group>
    </Modal>
  );
}
